import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import moment from "moment";
import AgGridTable from '../../../../utilities/AgGridTable';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import uploadSingleFilePopup from '../upload-component/uploadSingleFilePopup';
import CustomDatePicker from 'src/app/main/utilities/CustomDatePicker';


/* -------------------------------- issueDate -------------------------------- */
const issueDate = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [issueDate, setIssueDate] = useState(null);

    const handleIssueDateChange = (newValue) => {
        setIssueDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {

        if (props.data.issueDate) {
            setIssueDate(props.data.issueDate);
        }
    }, [props.data])


    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (issueDate !== null) {
                    return moment(issueDate).format('YYYY-MM-DD');
                }
            }
        };
    });
    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'issueDate'}
            value={issueDate ? issueDate : (!props.data.issueDate ? null : props.data.issueDate)}
            handleChange={handleIssueDateChange}
            ref={refDatePicker}
        />
    );
});

/* -------------------------------- expiryDate -------------------------------- */
const expiryDate = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [expiryDate, setExpiryDate] = useState(null);

    const handleExpiryDateChange = (newValue) => {
        setExpiryDate(moment(newValue).format('YYYY-MM-DD'));
    };
    useEffect(() => {
        if (props.data.expiryDate) {
            setExpiryDate(props.data.expiryDate);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (expiryDate !== null) {
                    return moment(expiryDate).format('YYYY-MM-DD');
                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'expiryDate'}
            value={expiryDate ? expiryDate : (!props.value ? null : props.value)}
            handleChange={handleExpiryDateChange}
            ref={refDatePicker}
        />
    );
});

const docData = [
    { documentName: "Emirates ID", issueDate: "", expiryDate: "", uploadFile: "" },
    { documentName: "Employment Visa", issueDate: "", expiryDate: "", uploadFile: "" },
    { documentName: "Labor Card", issueDate: "", expiryDate: "", uploadFile: "" },
    { documentName: "Health Insurance Card", issueDate: "", expiryDate: "", uploadFile: "" },
    { documentName: "Driving License", issueDate: "", expiryDate: "", uploadFile: "" },
]

const DocumentsDetail = ({ personalInfo, setSnackState, setSuccessMsg }) => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.documentInfoes}`
    const requireDocument = ["Emirates ID", "Employment Visa", "Labor Card", "Health Insurance Card"]
    const gridRef = useRef();
    const params = useParams();
    const [gridApi, setGridApi] = useState(null);
    const [documentsFile, setDocumentFile] = useState(docData);
    const [uploadDocument, setUploadDocument] = useState([]);
    const [disabled, setDisableb] = useState(true);

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [documentColumnDefs, setDocumentColumnDefs] = useState([
        { field: 'file', enableRowGroup: false, hide: true, editable: false },
        {
            field: 'documentName', enableRowGroup: true, cellRenderer: (props) => {
                if (requireDocument.filter((item) => item === props.value).length > 0) {
                    return <p>*{props.value}</p>
                } else {
                    return <p>{props.value}</p>
                }
            }
        },
        { field: 'issueDate', enableRowGroup: true, cellEditor: issueDate, cellRenderer : handleDateFormat  },
        { field: 'expiryDate', enableRowGroup: true, cellEditor: expiryDate, cellRenderer : handleDateFormat  },
        { field: 'notifactionDays', enableRowGroup: true, headerName: "Notification Days" },
        {
            field: 'uploadFile', enableRowGroup: true, cellEditor: uploadSingleFilePopup, cellStyle: {
                textAlign: 'right',
            }
        }
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [documentsFile]);


    const getPersonalDoc = async () => {
        try {
            const documentInfoesList = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
            const personalDocuments = documentInfoesList.data?._embedded?.documentInfoes;
            let document = personalDocuments.filter((doc) => doc.employeeId == personalInfo.employeeId);
            document = document.map((item) => {
                return {
                    docId: item.docId,
                    documentName: item.documentName,
                    documentType: item.documentType,
                    empId: item.employeeId,
                    issueDate: item.issueDate,
                    expiryDate: item.expiryDate,
                    notifactionDays: item.notifactionDays,
                    uploadFile: item.uploadFile
                }
            })
            if (document.length > 0) {
                setDocumentFile(document);
            } else {
                setDocumentFile(docData);
            }
        } catch (error) {
            // setError(error.message);
        }
    }
    useEffect(() => {
        if (params.id) {
            getPersonalDoc();
        }
    }, [params.id, personalInfo])


    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {

        }
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // documentsFile.splice(RowIndex, 0, newRow);
        // uploadDocument.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'documentName')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'documentName',
            });
        }, 800);
    }, [documentsFile, uploadDocument]);

    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'documentName')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'documentName',
        });

    }, [documentsFile]);

    // const onBtCopyRow = useCallback((event) => {
    // }, []);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        documentsFile.splice(event.node.rowIndex, 1);
        uploadDocument.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
        selectedRow.map(async (row) => {
            await OAuthService.deleteData(url, row.docId);
        })
    }, [gridApi, documentsFile])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            // {
            //     name: "Copy Row",
            //     icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
            //     action: () => {
            //         onBtCopyRow(event);
            //     },
            // },
            {
                name: "Delete Row",
                disabled: !data || requireDocument.includes(data?.documentName),
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;


        const model = {
            docId: data.docId ? data.docId : "",
            documentName: data.documentName,
            issueDate: data.issueDate,
            expiryDate: data.expiryDate,
            empId: params.id ? params.id : personalInfo.employeeId,
            file: data.file,
            notifactionDays: data.notifactionDays,
            rowIndex: event.node.rowIndex
        }
        if (params.id) {
            if (data.docId) {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.docId === event.node.data.docId) {
                            item.documentName = data.documentName;
                            item.issueDate = data.issueDate;
                            item.expiryDate = data.expiryDate;
                            item.notifactionDays = data.notifactionDays;
                            item.empId = params.id ? params.id : personalInfo.employeeId;
                            item.file = data.file;
                        }
                        return item;
                    });
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            } else {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.rowIndex === event.node.rowIndex) {
                            item.documentName = data.documentName;
                            item.issueDate = data.issueDate;
                            item.expiryDate = data.expiryDate;
                            item.notifactionDays = data.notifactionDays;
                            item.empId = params.id ? params.id : personalInfo.employeeId;
                            item.file = data.file;
                        }
                        return item;
                    })
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            }

        } else {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                        item.documentName = data.documentName;
                        item.issueDate = data.issueDate;
                        item.expiryDate = data.expiryDate;
                        item.notifactionDays = data.notifactionDays;
                        item.empId = params.id ? params.id : personalInfo.employeeId;
                        item.file = data.file;
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        }

    }, [uploadDocument, personalInfo]);


    useEffect(() => {
        const required = uploadDocument.filter((item) => requireDocument.includes(item.documentName));

        if (params.id) {
            setDisableb(false);
        }
        if (required.length >= 4) {
            const demo = required.map((item) => Object.values(item).every(value => {
                if (value !== undefined) {
                    return true;
                    // setDisableb(false);
                }
                return false;
            }));
            if (demo.every(element => element === true)) {
                setDisableb(false);
            }
        }
    }, [uploadDocument])


    /*---------------------------------------------------------------------------------------------*/





    const handleSubmit = async () => {
        try {
            if (uploadDocument.length === 0) {
                setSuccessMsg("Please fill all field");
                setSnackState(true);
                setTimeout(() => { setSnackState(false) }, 2000);
            }
            await Promise.all(uploadDocument.map(async (upload, index) => {
                try {
                    const formData = new FormData();
                    formData.append('File', upload.file);
                    const type = upload?.file?.name?.split(".").pop();
                    const fileName = upload?.file?.name;
                    const uploadDocUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.uploadMultipleFile}?documentName=${upload.documentName}&documentType=${type}&issueDate=${upload.issueDate}&expiryDate=${upload.expiryDate}&empId=${upload.empId}&uploadFile=${fileName}&notifactionDays=${upload.notifactionDays}`

                    // if(upload)
                    if (upload.documentName && upload.issueDate && upload.expiryDate && upload.notifactionDays && upload.file.length !== 0) {
                        if (upload.file.length === 0) {
                            if (upload.docId) {
                                if (upload.issueDate && upload.expiryDate) {
                                    const responce = await OAuthService.updateData(url, upload.docId, upload);
                                    if (responce.status === 200) {
                                        setSuccessMsg("Update document successfully");
                                        setSnackState(true);
                                        setTimeout(() => { setSnackState(false) }, 2000);
                                    }
                                }
                            }
                        } else {
                            if (upload.docId) {
                                await OAuthService.deleteData(url, upload.docId);
                            }
                            console.log("ELSE")
                            const responce = await OAuthService.uploadFile(uploadDocUrl, formData);
                            if (responce.status === 200) {
                                setSuccessMsg("Upload document successfully");
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 2000);
                            }
                        }
                    } else {
                        console.log("unSuccuessful......");
                        setSuccessMsg("Please fill all field");
                        setSnackState(true);
                        setTimeout(() => { setSnackState(false) }, 2000);
                    }

                } catch (error) {
                    console.log('error', error);
                }
            }))
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div>
            <div className='flex justify-between items-center mb-16'>
                <Typography color={"error"}>* Please upload below required document</Typography>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                    disabled={disabled}
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    Save Document
                </Button>
            </div>
            <div style={{ height: "500px" }}>
                <AgGridTable
                    columnDefs={documentColumnDefs}
                    rowData={documentsFile}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    onRowValueChanged={onRowValueChanged}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'documentsInfo'}
                />
            </div>
        </div>
    )
}

export default DocumentsDetail